import { useMemo } from 'react'
import { FormatNumberOptions, IntlShape } from 'react-intl'

export const usePlaceholder = (intl: IntlShape, placeholder?: string, currency?: string, isLoading?: boolean) => {
  return useMemo(() => {
    if (isLoading) {
      return ''
    }

    if (placeholder) {
      return placeholder
    }

    const options: FormatNumberOptions = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }

    if (currency) {
      options.style = 'currency'
      options.currency = currency
    }

    return intl.formatNumber(0, options)
  }, [intl, placeholder, currency, isLoading])
}
